import axios from 'axios'
import createAlert from './modal/createAlert'
import { removeLoader } from './loader'
import { _ } from './gettext'

/**
 * @param options
 * @param {function|null} onError
 * @returns {Promise<{data: {error: boolean}}|{then(): {data: {error: boolean}}}|AxiosResponse<any>>}
 */
export async function ajax (options, onError = null) {
  let axiosRequest
  let err = null

  try {
    axiosRequest = await axios(options)
  } catch (e) {
    err = e
  }

  if (err) {
    return {
      then () {
        const errorMessage = err.response?.data.message || err.message ||
          _('Při provádění požadavku došlo k chybě. Zkuste prosím akci opakovat později. Děkujeme')

        !options.suppressErrorAlert && createAlert(errorMessage).show()
        typeof onError === 'function' ? onError(errorMessage) : removeLoader()

        return {
          data: {
            error: true
          }
        }
      }
    }
  } else {
    return axiosRequest
  }
}
